/* IC BREW CUES v1.0
   Sunet + vibratie + wake lock peste brew timer-ul existent.
   - Sunet: Web Audio API (oscillator beeps, fara fisier audio).
   - Vibratie: navigator.vibrate (Android only — iOS Safari nu suporta, cade silentios).
   - Wake Lock: previne ecranul sa se stinga in timpul brewing-ului.
   - iOS: AudioContext este unlock-uit la primul click pe Start (gest user obligatoriu).
   - Toggle Sunet ON/OFF langa butoanele Start/Reset.
*/
(function(){
  'use strict';

  var soundEnabled = true;
  var audioCtx = null;
  var wakeLock = null;
  var schedule = null;
  var startMs = 0;
  var pollId = null;
  var lastCueIdx = -1;
  var running = false;

  function lang() { return document.documentElement.getAttribute('data-lang') || 'ro'; }

  function unlockAudio(){
    if (!audioCtx) {
      try { var Ctx = window.AudioContext || window.webkitAudioContext; if (Ctx) audioCtx = new Ctx(); } catch(e){}
    }
    if (audioCtx && audioCtx.state === 'suspended') {
      audioCtx.resume().catch(function(){});
    }
  }

  function beep(type){
    if (!soundEnabled || !audioCtx) return;
    var now = audioCtx.currentTime;
    var freqs, dur, gap;
    if (type === 'start')     { freqs = [523];           dur = 0.18; gap = 0.00; }
    else if (type === 'pour') { freqs = [659];           dur = 0.22; gap = 0.00; }
    else if (type === 'done') { freqs = [523, 659, 784]; dur = 0.24; gap = 0.06; }
    else                      { freqs = [550];           dur = 0.15; gap = 0.00; }
    for (var i = 0; i < freqs.length; i++) {
      var osc = audioCtx.createOscillator();
      var g = audioCtx.createGain();
      osc.type = 'sine';
      osc.frequency.value = freqs[i];
      var t0 = now + i * (dur + gap);
      g.gain.setValueAtTime(0.0001, t0);
      g.gain.exponentialRampToValueAtTime(0.32, t0 + 0.02);
      g.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);
      osc.connect(g); g.connect(audioCtx.destination);
      osc.start(t0);
      osc.stop(t0 + dur + 0.05);
    }
  }

  function vib(type){
    if (!soundEnabled || !navigator.vibrate) return;
    try {
      if (type === 'start')      navigator.vibrate([180]);
      else if (type === 'pour')  navigator.vibrate([200]);
      else if (type === 'done')  navigator.vibrate([200, 90, 200, 90, 350]);
      else                       navigator.vibrate(150);
    } catch(e){}
  }

  function cue(type){ beep(type); vib(type); }

  function requestWakeLock(){
    if (!('wakeLock' in navigator)) return;
    try {
      navigator.wakeLock.request('screen').then(function(wl){
        wakeLock = wl;
        wakeLock.addEventListener('release', function(){ wakeLock = null; });
      }).catch(function(){});
    } catch(e){}
  }
  function releaseWakeLock(){
    if (wakeLock) {
      try { wakeLock.release(); } catch(e){}
      wakeLock = null;
    }
  }
  // Re-acquire wake lock cand tab-ul devine visible din nou
  document.addEventListener('visibilitychange', function(){
    if (running && document.visibilityState === 'visible' && !wakeLock) requestWakeLock();
  });

  function parseTimeStr(s){
    var m = (s||'').match(/(\d+):(\d+)/);
    if (!m) return 180;
    return parseInt(m[1],10) * 60 + parseInt(m[2],10);
  }
  function parseBloomSec(s){
    var m = (s||'').match(/(\d+)\s*s/i);
    if (!m) return 30;
    return parseInt(m[1],10);
  }

  function computeSchedule(){
    var totalEl = document.getElementById('brewTotal') || document.getElementById('derivedTime');
    var bloomEl = document.getElementById('derivedBloom');
    var total = parseTimeStr(totalEl && totalEl.textContent);
    var bloom = parseBloomSec(bloomEl && bloomEl.textContent);
    if (total < 30) total = 180;
    if (bloom < 10) bloom = 30;
    if (bloom > total - 10) bloom = Math.max(10, total - 30);

    var cues = [{ at: 0, type: 'start' }];
    if (bloom > 0 && bloom < total - 5) {
      cues.push({ at: bloom, type: 'pour' });
    }
    var mid = bloom + Math.floor((total - bloom) / 2);
    if (mid > bloom + 8 && mid < total - 8) {
      cues.push({ at: mid, type: 'pour' });
    }
    cues.push({ at: total, type: 'done' });
    return { cues: cues, total: total };
  }

  function poll(){
    if (!running || !schedule) return;
    var elapsed = Math.floor((Date.now() - startMs) / 1000);
    while (lastCueIdx + 1 < schedule.cues.length && schedule.cues[lastCueIdx + 1].at <= elapsed) {
      lastCueIdx++;
      var c = schedule.cues[lastCueIdx];
      cue(c.type);
      if (c.type === 'done') { stop(); return; }
    }
    pollId = setTimeout(poll, 250);
  }

  function start(){
    unlockAudio();
    requestWakeLock();
    schedule = computeSchedule();
    startMs = Date.now();
    lastCueIdx = -1;
    running = true;
    if (pollId) { clearTimeout(pollId); pollId = null; }
    poll();
  }
  function stop(){
    running = false;
    releaseWakeLock();
    if (pollId) { clearTimeout(pollId); pollId = null; }
  }

  function injectCss(){
    if (document.getElementById('icCueStyles')) return;
    var s = document.createElement('style');
    s.id = 'icCueStyles';
    s.textContent =
      '.ic-cue-toggle{display:inline-flex;align-items:center;gap:8px;padding:8px 14px;background:rgba(245,240,232,.04);border:1px solid rgba(245,240,232,.15);color:#F5F0E8;font-family:Lato,sans-serif;font-size:10px;font-weight:700;letter-spacing:.2em;text-transform:uppercase;cursor:pointer;transition:opacity .2s,background .2s,border-color .2s;border-radius:2px}'+
      '.ic-cue-toggle[data-on="true"]{border-color:rgba(232,154,31,.5);background:rgba(232,154,31,.08)}'+
      '.ic-cue-toggle[data-on="false"]{opacity:.55}'+
      '.ic-cue-toggle:hover{opacity:.85}'+
      '.ic-cue-toggle .ic-cue-dot{width:8px;height:8px;border-radius:50%;background:#E89A1F;transition:background .2s}'+
      '.ic-cue-toggle[data-on="false"] .ic-cue-dot{background:rgba(245,240,232,.3)}';
    document.head.appendChild(s);
  }

  function injectToggle(){
    var actions = document.querySelector('.brew-timer-actions');
    if (!actions || document.getElementById('icCueToggle')) return;
    var t = document.createElement('button');
    t.id = 'icCueToggle';
    t.className = 'ic-cue-toggle';
    t.type = 'button';
    t.setAttribute('data-on', 'true');
    t.setAttribute('aria-pressed', 'true');
    t.innerHTML = '<span class="ic-cue-dot" aria-hidden="true"></span><span class="ic-cue-label">Sunet</span>';
    if (lang() === 'en') t.querySelector('.ic-cue-label').textContent = 'Sound';
    actions.appendChild(t);
    t.addEventListener('click', function(){
      soundEnabled = !soundEnabled;
      t.setAttribute('data-on', soundEnabled ? 'true' : 'false');
      t.setAttribute('aria-pressed', soundEnabled ? 'true' : 'false');
      if (soundEnabled) unlockAudio();
    });
  }

  function hookButtons(){
    var startBtn = document.getElementById('brewStartBtn');
    var resetBtn = document.getElementById('brewResetBtn');
    if (!startBtn || startBtn.dataset.icCueHooked === '1') return !!(startBtn && resetBtn);
    startBtn.dataset.icCueHooked = '1';
    if (resetBtn) resetBtn.dataset.icCueHooked = '1';

    startBtn.addEventListener('click', function(){
      unlockAudio();
      setTimeout(function(){
        if (running) {
          stop();
        } else {
          start();
        }
      }, 10);
    });
    if (resetBtn) resetBtn.addEventListener('click', function(){ stop(); });
    return true;
  }

  function init(){
    injectCss();
    var ok = hookButtons();
    injectToggle();
    if (!ok) setTimeout(init, 250);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
